import { z } from 'zod'

import { apiRequest } from '@/api/client'

const userSchema = z.object({
  id: z.number(),
  username: z.string(),
  email: z.string(),
  full_name: z.string(),
  whatsapp_number: z.string().nullable().optional(),
  business_name: z.string().nullable().optional(),
  role: z.enum(['vendor', 'admin']),
})

const authResponseSchema = z.object({
  token: z.string(),
  user: userSchema,
})

export type AuthUserProfile = z.infer<typeof userSchema>
export type AuthResponse = z.infer<typeof authResponseSchema>

export function loginRequest(payload: { login: string; password: string }) {
  return apiRequest('/api/v1/auth/login', (data) => authResponseSchema.parse(data), {
    method: 'POST',
    body: payload,
    authenticated: false,
    bearer: false,
  })
}

export function registerVendorRequest(payload: {
  username: string
  email: string
  password: string
  full_name: string
  whatsapp_number: string
  business_name?: string
}) {
  return apiRequest('/api/v1/auth/register', (data) => authResponseSchema.parse(data), {
    method: 'POST',
    body: payload,
    authenticated: false,
    bearer: false,
  })
}

export function fetchMyProfile() {
  return apiRequest('/api/v1/auth/me', (data) => z.object({ user: userSchema }).parse(data))
}

export function updateMyProfile(payload: {
  full_name: string
  email: string
  whatsapp_number?: string | null
  business_name?: string | null
}) {
  return apiRequest('/api/v1/auth/me', (data) => z.object({ user: userSchema }).parse(data), {
    method: 'PATCH',
    body: payload,
  })
}

export function changeMyPassword(payload: { current_password: string; new_password: string }) {
  return apiRequest('/api/v1/auth/change-password', (data) => z.object({ ok: z.boolean() }).parse(data), {
    method: 'POST',
    body: payload,
  })
}
